import { PostAPI } from 'Components/Helper/Helpers';

export const Update = async (request) => {
    return PostAPI(request, 'PlanSetting/Update');
};

export const Select = async (request) => {
    return PostAPI(request, 'PlanSetting/Select');
};

export const IsOnOff = async (request) => {
    return PostAPI(request, 'PlanSetting/IsOnOff');
};
